import { useQuery } from '@tanstack/react-query';

import { UnwrapArray } from '@sbv-clients/util-misc';

import { useApi } from '../index';
import { AbsencesCacheKeys } from './util/cache-keys';

export const useAbsencesReasonsPlannedAbsencesGet = () => {
  const api = useApi();
  return useQuery({
    queryKey: [AbsencesCacheKeys.AbsenceReasonsPlannedAbsences],
    queryFn: () =>
      api.absencesApi
        .absencesAbsenceReasonsPlannedAbsencesGet()
        .then((response) => response.data ?? []),
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};

export type AbsenceReasonResponseType = NonNullable<
  UnwrapArray<ReturnType<typeof useAbsencesReasonsPlannedAbsencesGet>['data']>
>;

export const useAbsencesReasonsSchedulerGet = () => {
  const api = useApi();
  return useQuery({
    queryKey: [AbsencesCacheKeys.AbsenceReasonsScheduler],
    queryFn: () =>
      api.absencesApi
        .absencesAbsenceReasonsSchedulerGet({})
        .then((response) => response.data ?? []),
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};
